import styled from 'styled-components';

export const InfoBtn = styled.button(({ theme }) => ({
  backgroundColor: 'transparent',
  border: 'none',
  padding: '5rem',
  borderRadius: '10rem',

  cursor: 'pointer',

  color: theme.palette.coolBlack,
  fontSize: theme.typography.size20,

  svg: {
    display: 'block',
  },
}));
